import type * as Types from '../../types/graphql';

import type { ComputedRef, Ref } from 'vue';
import { useQuery, type UseQueryOptions } from 'vue-query';
import { appFetcher } from '../../utils/gatewayClient';
export type ShopPlatformQueryVariables = Types.Exact<{
  appType?: Types.InputMaybe<Types.AppType>;
  platformDomain?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ShopPlatformQueryResponse = {
  shopPlatform?: Types.Maybe<
    Pick<
      Types.ShopPlatform,
      'appType' | 'id' | 'currency' | 'platform' | 'status' | 'platformDomain' | 'platformStoreID'
    >
  >;
};

export const ShopPlatformDocument = `
    query ShopPlatform($appType: AppType, $platformDomain: String) {
  shopPlatform(appType: $appType, platformDomain: $platformDomain) {
    appType
    id
    currency
    platform
    status
    platformDomain
    platformStoreID
  }
}
    `;
export const useShopPlatformQuery = <TData = ShopPlatformQueryResponse, TError = unknown>(
  variables?: ShopPlatformQueryVariables | ComputedRef<ShopPlatformQueryVariables> | Ref<ShopPlatformQueryVariables>,
  options?: UseQueryOptions<ShopPlatformQueryResponse, TError, TData>,
) =>
  useQuery<ShopPlatformQueryResponse, TError, TData>(
    variables === undefined ? ['ShopPlatform'] : ['ShopPlatform', variables],
    appFetcher<ShopPlatformQueryResponse, ShopPlatformQueryVariables>(ShopPlatformDocument, variables),
    options,
  );

useShopPlatformQuery.getKey = (
  variables?: ShopPlatformQueryVariables | ComputedRef<ShopPlatformQueryVariables> | Ref<ShopPlatformQueryVariables>,
) => (variables === undefined ? ['ShopPlatform'] : ['ShopPlatform', variables]);
